import {
  ICrmLeadOrigemCleanDTO,
  ICrmLeadOrigemDTO,
  ICrmLeadOrigemFullDTO
} from '../models/happy-code-api.model';
import { baseFindList } from './base/base-find-list.service';

export const useLeadOrigemService = () => {
	const resourceURL = 'crm/lead-origem';

	return {
		...baseFindList<ICrmLeadOrigemCleanDTO, ICrmLeadOrigemDTO, ICrmLeadOrigemFullDTO>(resourceURL),
	};
};
